run.$inject = ['$rootScope', '$templateCache', '$state', '$stateParams', '$timeout', 'MenuConstant', 'workplan']

export default function run ($rootScope, $templateCache, $state, $stateParams, $timeout, MenuConstant, workplan) {


  $templateCache.put('autoevaluacion.html', require('./partials/review/summary/evaluacionDeProfesoresTemplates/autoevaluacion.html'))

  $templateCache.put('reflexionesDePortafolio.html', require('./partials/review/summary/evaluacionDeProfesoresTemplates/reflexionesDePortafolio.html'))

  $templateCache.put('resultadosDeApreciacion.html', require('./partials/review/summary/evaluacionDeProfesoresTemplates/resultadosDeApreciacion.html'))
  
  $templateCache.put('comentariosDeConsultores.html', require('./partials/review/summary/evaluacionDeProfesoresTemplates/comentariosDeConsultores.html'))

  $templateCache.put('reflexionesDePares.html', require('./partials/review/summary/evaluacionDeProfesoresTemplates/reflexionesDePares.html'))  

  MenuConstant[0]['menu'].push(workplan)
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/workplan.run.js